/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".line[_ngcontent-%COMP%]{border-bottom:1px solid #cecece;margin-bottom:5px;padding-bottom:5px}.line[_ngcontent-%COMP%]:last-child{border:none}.image[_ngcontent-%COMP%]{margin-right:15px;width:50px;height:50px}.img[_ngcontent-%COMP%]{border-radius:50%;width:100%}.name[_ngcontent-%COMP%]{color:#000;font-size:17px}"];
export { styles as styles };
